'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the regulatory data and logos to be displayed on the footer.
 * @note: due to the way this endpoint is implemented in squiz, an error will never be sent on the response body.
 * @param {GetRegulatoryDataParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @param {String} [params.lang] The language to get the data for. Defaults to 'en-gb'
 * @returns {Promise<RegulatoryDataType>} A map of the required data containing: responsibleGambling text; list of
 * logos; cookieInfo and license info
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$lang, lang, tunnel, _params$siteType, siteType, siteTypeUrl, endpoint, proxyAgent, response;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, tunnel = params.tunnel, _params$siteType = params.siteType, siteType = _params$siteType === undefined ? 'default' : _params$siteType;
                        siteTypeUrl = siteType === 'default' ? '' : '-' + siteType;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/sportsbook' + siteTypeUrl + '/' + lang + '/site-base/regulatory.json');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 6;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 6:
                        response = _context.sent;
                        return _context.abrupt('return', (0, _model2.default)(response.data));

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getRegulatoryData(_x) {
        return _ref.apply(this, arguments);
    }

    return getRegulatoryData;
}();
//# sourceMappingURL=regulatory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/regulatory/regulatory.js
// module id = 458
// module chunks = 0